import React, { Component } from 'react';
import { Redirect } from 'react-router'


class ChangeStore extends Component {
  componentWillMount =() => {
    localStorage.removeItem('selectedStore');
  }

  render(props) {
    return (
      <div className="app-content">
        <Redirect to='/'/>
      </div>
    );
  }
}

export default ChangeStore 



// WEBPACK FOOTER //
// ./src/components/ChangeStore.js